// Placeholder: https://cdn.shopify.com/s/files/1/0494/7918/8636/files/artist_placeholder.png?v=1717685478

const jhsTestimonialData = [
  {
    name: "Walt Druce",
    image: "https://cdn.shopify.com/s/files/1/0494/7918/8636/files/artist_waltdruce.png?v=1744253621",
    quote: "It reacts like a real amp should—punches when you dig in, backs off when you ease up. No surprises, just tone that makes sense.",
    credits: "Guitarist, Singer & Songwriter",
    productLogo: "https://cdn.shopify.com/s/files/1/0494/7918/8636/files/jhs_limg_header_logo-row.webp?v=1742260496",
    productURL: "jhs-loud-is-more-good-collection",
    productName: "JHS Loud Is More Good Collection",
    readMoreURL: "#jhs"
  },
  {
    name: "Sarah Longfield",
    image: "https://cdn.shopify.com/s/files/1/0494/7918/8636/files/artist_sarahlongfield.png?v=1744253622",
    quote: "My favorite thing about it is how it FEELS. It doesn't just sound great, but it responds like an actual amp.",
    credits: "Guitarist",
    productLogo: "https://cdn.shopify.com/s/files/1/0494/7918/8636/files/jhs_limg_header_logo-row.webp?v=1742260496",
    productURL: "jhs-loud-is-more-good-collection",
    productName: "JHS Loud Is More Good Collection",
    readMoreURL: "#jhs"
  },
  {
    name: "Nicholas Veinoglou",
    image: "https://cdn.shopify.com/s/files/1/0494/7918/8636/files/artist_NicholasVeinoglou.png?v=1744254119",
    quote: "MixWave's JHS Loud Is More Good plugin is an absolutely lethal weapon in the studio. Dial in record worthy tones in seconds! This plugin is so intuitive and easy to use AND it acts and responds like a real amp!",
    credits: "Guitarist",
    productLogo: "https://cdn.shopify.com/s/files/1/0494/7918/8636/files/jhs_limg_header_logo-row.webp?v=1742260496",
    productURL: "jhs-loud-is-more-good-collection",
    productName: "JHS Loud Is More Good Collection",
    readMoreURL: "#jhs"
  },
  {
    name: "Charlie Robbins",
    image: "https://cdn.shopify.com/s/files/1/0494/7918/8636/files/artist_charlierobbins.png?v=1744253621",
    quote: "Being able to have some of the best pedals in a digital form is so cool. I own a real Morning Glory and it sounds just as amazing in the box!",
    credits: "Guitarist",
    productLogo: "https://cdn.shopify.com/s/files/1/0494/7918/8636/files/jhs_limg_header_logo-row.webp?v=1742260496",
    productURL: "jhs-loud-is-more-good-collection",
    productName: "JHS Loud Is More Good Collection",
    readMoreURL: "#jhs"
  },
  {
    name: "Chillytoy",
    image: "https://cdn.shopify.com/s/files/1/0494/7918/8636/files/artist_chillytoy.png?v=1744253621",
    quote: "It's been a while since I've had this much fun using a plugin. Having access to Josh Scott's genius mind for guitar tones is a cheat code for musical inspiration.",
    credits: "Guitarist",
    productLogo: "https://cdn.shopify.com/s/files/1/0494/7918/8636/files/jhs_limg_header_logo-row.webp?v=1742260496",
    productURL: "jhs-loud-is-more-good-collection",
    productName: "JHS Loud Is More Good Collection",
    readMoreURL: "#jhs"
  },
  {
    name: "Bearamic",
    image: "https://cdn.shopify.com/s/files/1/0494/7918/8636/files/artist_bearamic.png?v=1744253621",
    quote: "JHS Loud Is More Good Collection is really good and versatile. It’s not only good with guitar, try it with something else like drums, synths or vocals, it will surprise you!",
    credits: "Guitarist, Producer & Composer",
    productLogo: "https://cdn.shopify.com/s/files/1/0494/7918/8636/files/jhs_limg_header_logo-row.webp?v=1742260496",
    productURL: "jhs-loud-is-more-good-collection",
    productName: "JHS Loud Is More Good Collection",
    readMoreURL: "#jhs"
  },
  {
    name: "Jon Suh",
    image: "https://cdn.shopify.com/s/files/1/0494/7918/8636/files/artist_jonsuh.png?v=1744252278",
    quote: "This plugin has a lot of versatility. It sounds great on its own, and it’s easy to layer different effects on top of each other for some unique sounds.",
    credits: "Guitarist",
    productLogo: "https://cdn.shopify.com/s/files/1/0494/7918/8636/files/jhs_limg_header_logo-row.webp?v=1742260496",
    productURL: "jhs-loud-is-more-good-collection",
    productName: "JHS Loud Is More Good Collection",
    readMoreURL: "#jhs"
  },
  {
    name: "Adam Dodson",
    image: "https://cdn.shopify.com/s/files/1/0494/7918/8636/files/artist_adamdodson.png?v=1744253621",
    quote: "All the flexibility of working digitally, but with the classic tones of JHS pedals — it’s the best of both worlds.",
    credits: "Guitarist",
    productLogo: "https://cdn.shopify.com/s/files/1/0494/7918/8636/files/jhs_limg_header_logo-row.webp?v=1742260496",
    productURL: "jhs-loud-is-more-good-collection",
    productName: "JHS Loud Is More Good Collection",
    readMoreURL: "#jhs"
  },
  {
    name: "Lucas Oliveira",
    image: "https://cdn.shopify.com/s/files/1/0494/7918/8636/files/artist_LucasOliveira.png?v=1745939251",
    quote: "MixWave did an incredible job bringing the JHS amplifier and its legendary pedals into the digital world, while preserving their main characteristic: transparent tone. With countless tools available, it opens up an infinite path of sonic possibilities. No matter what guitar or musical style you use, this plugin will be perfect for you.",
    credits: "Guitarist",
    productLogo: "https://cdn.shopify.com/s/files/1/0494/7918/8636/files/jhs_limg_header_logo-row.webp?v=1742260496",
    productURL: "jhs-loud-is-more-good-collection",
    productName: "JHS Loud Is More Good Collection",
    readMoreURL: "#jhs"
  }
];